import * as Sentry from '@sentry/react';

export const localStorageService = {
  get: <T>(key: string): T | null => {
    const value = localStorage.getItem(key);

    if (value === null) {
      return null;
    }

    try {
      return JSON.parse(value) as T;
    } catch (error) {
      Sentry.captureException(error, {
        extra: {
          key,
          value,
          message: `Error parsing localStorage key "${key}" with value "${value}" as JSON`,
        },
      });

      return null;
    }
  },
  getString: (key: string): string | null => {
    return localStorage.getItem(key);
  },
  set: (key: string, value: string): void => {
    localStorage.setItem(key, value);
  },
  remove: (key: string): void => {
    localStorage.removeItem(key);
  },
  clear: (): void => {
    localStorage.clear();
  },
};
